import "@/scss/main.scss";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 375,
      sm: 576,
      md: 768,
      lg: 992,
    },
    scrollBarWidth: 24,
  },
  theme: {
    options: {
      customProperties: true, // create css variables from theme colours
      variations: false, // allow light/dark theme colour variants
    },
    themes: {
      light: {
        accent: "#007185",
        psorange: "#fab519",
        psdarkgreen: "#106175",
        green: "#1d8649",
        primary: "#272727",
        webgrey: "#7c869a",
        lightgrey: "#f5f5f7",
        footergrey: "#363636",
        mustard: "#FAB519",
        steelygrey: "#665D58",
        mint: "#8FC99D",
        berrysmoothie: "#CF6A86",
        nordicsky: "#67B5BA",
        thistle: "#A190A3",
        navy: "#071F36",
        orange: "#F18A22",
        teal: "#009BA4",
        firstdawn: "#BCD1D2",
        background: "#E9EAEA",
        limegreen: "#D1D834",
        juicyred: "#E50046",
        purplepout: "#473185",
        wolfy: "#071215",
        hippo: "#C3C1BA",
        putty: "#DEE0CE",
        blueberrypopover: "#5285C0",
        error: "#df3044",
        radiobutton: "#2a2a2a",
        limedSpruce: "#354048",
        concrete: "#F3F3F3",
        bordergrey: "#B4B4B4",
        whitesmoke: "#F5F5F5",
        bggrey: "#F2F2F2",
        lynxwhite: "F7F7F7",
        cyanazure: "#4D7FB8",
        placeboblue: "#EBF5FD",
        doeskin: "#FFF1E4",
        suncrete: "#FB8C00",
        powderlilac: "#BDC3CD",
      },
    },
  },
});
